import { schemas } from 'constants/schemas';
import { normalize } from 'normalizr';
import { recipients } from 'services/apiV3/recipients/recipients';

export const fetch = async ({ id, recipientId, country, locale }) => {
  const offer = await recipients.fetchOffer({
    id,
    recipientId,
    country,
    locale,
  });

  return normalize(offer, schemas.offer);
};
